
<template>
  <el-dialog class="dialog-change-tags" title="批量修改发布者" :visible="visible" @update:visible="setVisible" width="550px">
    <ConfigForms ref="form" :form-items="formItems"></ConfigForms>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">取 消</el-button>
      <el-button type="primary" size="small" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms/index.vue';

export default {
  name: 'DialogSetPublishers',
  components: { ConfigForms },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formItems: [
        { label: '发布者', key: 'publisherID', required: true }
      ]
    };
  },

  mounted() {
    
  },

  methods: {
    setVisible(visible) {
      this.$emit('update:visible', visible)
    },
    close() {
      this.setVisible(false)
      this.$emit('close')
    },
    async sure() {
      try {
        const r = await this.$refs.form.validate()
        r.publisherID = parseInt(r.publisherID)
        this.$emit('submit', r)
      } catch (error) {
        
      }
    }
  },
};
</script>
